import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M2 7.314v9.372C2 19.952 4.312 22 7.585 22h8.83C19.688 22 22 19.962 22 16.686V7.314C22 4.038 19.688 2 16.415 2h-8.83C4.312 2 2 4.038 2 7.314",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m7.24 14.779 2.993-3.89 3.415 2.681 2.929-3.78"
    }, null, -1)
  ]))]))
}
export default { render: render }